import React, { useState, useEffect } from "react";
import * as Style from "./styledComponents/PersonalInstruction";
import Safe from "../assets/images/DeathModuleNew/Safe-1.png";
import SeeMore from "../assets/images/DeathModuleNew/more_horiz.png";
import TitleImg from "../assets/images/DeathModuleNew/Rectangle 34624117.png";

import menuIcon from "../assets/images/DeathModuleNew/Menu.png";
import fileIcon from "../assets/images/DeathModuleNew/Icons.png";
import AddModal from "./styledComponents/Modal/AddModal";
import UpdateModal from "./styledComponents/Modal/UpdateModal";
import ViewModal from "./styledComponents/Modal/ViewModal";
import helpIcon from "../assets/images/DeathModuleNew/IC_Help.png";
import { Modal } from "antd";
import Table from "./styledComponents/Table/Table";
import List from "./styledComponents/Table/List";
import MODULE_API from "../apis/module.api";
import DEATH_API from "../apis/death.api";
import axios from "axios";
import swal from "sweetalert";
import Loader from "../components/styled-components/loader/loader";
export const PersonalInstructions = (props) => {
  const [personalInstruction, setPersonalInstruction] = useState([]);
  const [dropdown, setDropdown] = useState(false);
  const [loading, setLoading] = useState(false);

  const [showModal, setShowModal] = useState(false);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);

  const [tooltipModal, setTooltipModal] = useState(false);
  const [addData, setAddData] = useState({});
  const [updateObject, setUpdateObject] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const handelCloseModal = () => {
    setAddData(null);
    setShowModal(false);
  };
  const handelCloseUpdateModal = () => {
    setShowUpdateModal(false);
  };
  const handelCloseViewModal = () => {
    setShowViewModal(false);
  };
  useEffect(() => {
    getPersonalInstruction();
  }, []);
  const getPersonalInstruction = async () => {
    try {
      // this.props.handleLoader();
      setAddData(null);
      console.log("setting add datato empty in get", addData);
      setLoading(true);
      const ID = localStorage.getItem("accessId");
      let data = await DEATH_API.fetchPersonalInstructions(ID);
      // console.log("personal instruction in componentdid mount..", data)
      // this.props.handleLoader();
      setLoading(false);
      if (data && data.data) {
        setPersonalInstruction(data.data);
        // this.setState({
        //   personal_instructions: data.data.map((item) => {
        //     item = {
        //       ...item,
        //       PersonalInstructions: item.text,
        //       title: item.title,
        //       UploadFileHere: item.fileName,
        //     };
        //     return item;
        //   }),
        // });
      }
    } catch (error) {
      // this.props.handleLoader()
      setLoading(false);
      console.log(error);
      throw new Error(error);
    }
  };
  const getSelectedRow = (idx, rows, name) => {
    console.log("idx>>>", idx);
    setSelectedIndex(idx);
    // get selected row (this will return array of object)
    console.log("rows", rows);
    let selectedRow = rows.filter((row, index) => {
      return row.id == idx;
    });
    // get first and only element from list and store it in update object
    console.log("selectedRow[0]", selectedRow[0]);
    setUpdateObject(selectedRow[0]);
  };

  const updatePersonalInstructions = async () => {
    try {
      // this.props.handleLoader()
      // let obj = {
      //   ...this.state.updateObject,
      // };
      setLoading(true);
      let obj = updateObject;
      let updateBody = {
        text: obj["text"],
        title: obj["title"],
        fileUrl: obj["fileUrl"],
        fileName: obj["fileName"],
      };
      console.log("obj111", obj);
      if (
        obj["Upload File Here"] &&
        typeof obj["Upload File Here"] != "string"
      ) {
        const formData = new FormData();
        formData.append("video", obj["Upload File Here"]);

        const name = obj["Upload File Here"].name;
        const lastDot = name.lastIndexOf(".");
        const fileName = name.substring(0, lastDot);
        const ext = name.substring(lastDot + 1);
        const resdata = await MODULE_API.uploadFile({
          fileExt: ext,
          contentType: obj["Upload File Here"].type,
        });
        const resupload = await axios.put(
          resdata.uploadUrl,
          obj["Upload File Here"],
          { headers: { "Content-type": obj["Upload File Here"].type } }
        );
        const res = resdata.uploadUrl.split("?")[0];
        console.log("resss video url", res);
        // const uploaded = await MODULE_API.uploadImage(formData);
        updateBody.fileUrl = res;
        updateBody.fileName = name;
        obj["Upload File Here"] = name;
        // const formData = new FormData();
        // formData.append("image", obj["UploadFileHere"]);
        // const uploaded = await MODULE_API.uploadImage(formData);
        // // console.log("updated file Url", uploaded.file_url);
        // updateBody.fileUrl = uploaded.file_url;
        // updateBody.fileName = obj["UploadFileHere"].name;
        // obj["UploadFileHere"] = obj["UploadFileHere"].name;
      }
      let api_res = await DEATH_API.updatePersonalInstructions(
        obj.id,
        updateBody
      );
      setLoading(false);
      // this.props.handleLoader();

      if (api_res) swal("Success!", "Data updated", "success");
      getPersonalInstruction();
      // let { personal_instructions, selectedIndex } = this.state;
      let index = selectedIndex - 1;
      personalInstruction = [...personalInstruction]; // important to create a copy, otherwise you'll modify state outside of setState call
      personalInstruction[index] = obj; // replace current updated object in personal_instructions based on index
      // this.setState({ personalInstruction }, () => {
      //   this.props.handleChecklistObject(
      //     this.props.currentForm,
      //     this.state.personal_instructions
      //   );
      // });
    } catch (error) {
      setLoading(false);
      // this.props.handleLoader();
      console.log(error);
      // swal("Error!!", "Not Updated", "error");
    }
  };
  const deleteSelectedRow = async (idx) => {
    // var that = this;
    swal({
      title: "Are you sure?",
      text: "Are you sure you want to delete this?",
      dangerMode: true,
      buttons: ["No, cancel it!", "Yes, delete it!"],
      icon: "warning",
      type: "warning",
      closeOnConfirm: false,
      closeOnCancel: false,
    }).then(async function (isConfirm) {
      // Redirect the user
      if (isConfirm) {
        // that.props.handleLoader();
        // setLoading(true);
        try {
          // that.props.handleLoader();
          setLoading(true);
          // const { personal_instructions } = that.state;
          await DEATH_API.deletePersonalInstruction(idx);
          // that.props.handleLoader();
          setLoading(false);

          const updatedRows = personalInstruction.filter((row, index) => {
            return row.id != idx;
          });
          setPersonalInstruction(updatedRows);
          getPersonalInstruction();
        } catch (error) {
          // console.log("error deleting Personal Instruction");
          console.log(error);
          setLoading(false);
          // that.props.handleLoader();
        }
        setTimeout(async () => {
          setLoading(true);
          // that.props.handleLoader();
          swal("Deleted!", "Your file has been deleted.", "success");
        }, 0);
      } else {
        swal("Cancelled", "Your file is safe :)", "error");
      }
    });

    // try {
    //   this.props.handleLoader();
    //   const { personal_instructions } = this.state;
    //   await DEATH_API.deletePersonalInstruction(idx);
    //   this.props.handleLoader();

    //   const updatedRows = personal_instructions.filter((row, index) => {
    //     return row.id != idx;
    //   });
    //   this.setState(
    //     {
    //       personal_instructions: updatedRows,
    //     },
    //     () => {
    //       this.props.handleChecklistObject(
    //         this.props.currentForm,
    //         this.state.personal_instructions
    //       );
    //     }
    //   );
    // } catch (error) {
    //   // console.log("error deleting Personal Instruction");
    //   console.log(error);
    //   this.props.handleLoader()

    // }
  };
  const fields = [
    {
      title: "Title",
      type: "input",
      index: "title",
    },
    {
      title: "Personal Instructions",
      type: "textarea",
      index: "PersonalInstructions",
    },

    {
      title: "Upload File Here",
      type: "file",
      index: "UploadFileHere",
    },
  ];
  const update_fields = [
    {
      title: "Title",
      type: "input",
      index: "title",
    },
    {
      title: "Personal Instructions",
      type: "textarea",
      index: "text",
    },
    {
      title: "Upload File Here",
      type: "file",
      index: "fileUrl",
    },
  ];
  const handlechange = (e) => {
    console.log("e", e.target);
    e.preventDefault();
    const { name, value } = e.target;

    setAddData({
      ...addData,
      [name]: value,
    });
  };
  const handleDocumentChange = (name, value) => {
    // console.log("e", e.target);
    // e.preventDefault();
    // const { name, value } = e.target;

    setAddData({
      ...addData,
      [name]: value,
    });
  };
  const handleDatePickerChange = (name, value) => {
    setAddData({
      ...addData,
      [name]: value,
    });
  };
  const handleRadioChange = (name, value) => {
    setAddData({
      ...addData,
      [name]: value,
    });
  };
  const handleUpdatechange = (e) => {
    console.log("e", e.target);
    e.preventDefault();
    const { name, value } = e.target;

    setUpdateObject({
      ...updateObject,
      [name]: value,
    });
  };
  const handleUpdateDocumentChange = (name, value) => {
    // console.log("e", e.target);
    // e.preventDefault();
    // const { name, value } = e.target;

    setUpdateObject({
      ...updateObject,
      [name]: value,
    });
  };
  const handleUpdateDatePickerChange = (name, value) => {
    setUpdateObject({
      ...updateObject,
      [name]: value,
    });
  };
  const handleUpdateRadioChange = (name, value) => {
    setUpdateObject({
      ...updateObject,
      [name]: value,
    });
  };
  const SubmitUpdate = () => {
    console.log("updated object", updateObject);
    updatePersonalInstructions();
    handelCloseUpdateModal();
  };
  const submitData = () => {
    console.log("submit data", addData);
    addPersonalInstructions();
    handelCloseModal();
  };
  const addPersonalInstructions = async () => {
    console.log("data", addData);
    try {
      // this.props.handleLoader()
      setLoading(true);
      let arr = [addData];
      console.log("arrrrrrrr", arr);
      let data = arr;
      console.log("data on next click", data);
      if (Array.isArray(data) && data.length > 0) {
        const allPromises = data.map(async (item) => {
          if (item["Upload File Here"]) {
            console.log("items.file", item);

            const formData = new FormData();
            formData.append("file", item["Upload File Here"]);
            console.log("item.file", item["Upload File Here"]);
            const name = item["Upload File Here"].name;
            const lastDot = name.lastIndexOf(".");
            const fileName = name.substring(0, lastDot);
            const ext = name.substring(lastDot + 1);
            const resdata = await MODULE_API.uploadFile({
              fileExt: ext,
              contentType: item["Upload File Here"].type,
            });
            const resupload = await axios.put(
              resdata.uploadUrl,
              item["Upload File Here"],
              { headers: { "Content-type": item["Upload File Here"].type } }
            );
            const res = resdata.uploadUrl.split("?")[0];
            console.log(res);
            delete item["Upload File Here"];
            return { ...item, fileUrl: res, fileName: name };
          }
          setAddData(null);
          console.log("setting add datato empty", addData);

          return item;
        });
        let res = await Promise.all(allPromises);
        console.log("res>>>>", res);
        let api_res = await DEATH_API.addPersonalInstructions({
          personalInstructionsForm: res.map((item) => {
            return {
              text: item.PersonalInstructions,
              title: item.Title,
              fileName: item.fileName,
              fileUrl: item.fileUrl,
            };
          }),
        });
        data = null;
        // this.props.handleLoader();
        setLoading(false);
        getPersonalInstruction();
        return api_res;
      }
    } catch (error) {
      setLoading(false);
      // this.props.handleLoader()
      console.log(error);
      throw new Error(error);
    }
    console.log("setting add datato empty", addData);
    setAddData(null);
  };
  const showTooltipModal = () => {
    setTooltipModal(true);
  };

  const handleTooltipCancel = () => {
    setTooltipModal(false);
  };

  const cols = [
    {
      title: "Title",
      dataIndex: "title",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Personal Instruction",
      dataIndex: "text",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "File",
      dataIndex: ["fileName", "fileUrl"],
      // render: (record) => (record ? record : "N/A"),
      render: (fileName, record) => {
        return record.fileUrl ? (
          <div style={{ display: "flex", alignItems: "center" }}>
            {" "}
            <a
              style={{ color: "#7d8fb3" }}
              href={record.fileUrl}
              target="blank">
              {" "}
              {record.fileName}
            </a>
          </div>
        ) : (
          "N/A"
        );
      },
    },

    {
      title: "Action",
      render: (record, index) => {
        return (
          <div>
            <div
              onClick={() => {
                console.log("recode", record.id);
                setDropdown(!dropdown);
                getSelectedRow(record.id, personalInstruction);
              }}
              style={{
                cursor: "pointer",
                marginRight: "1rem",
                padding: "0px 16px",
                width: "5px",
              }}>
              <img src={menuIcon} alt="menuIcon"></img>
            </div>
            {dropdown && selectedIndex === record.id && (
              <>
                <div
                  onClick={() => {
                    setDropdown(false);
                  }}
                  className=""
                  style={{
                    position: "fixed",
                    width: "100vw",
                    height: "100vh",
                    background: "black",
                    opacity: "0.1",
                    top: "0",
                    left: "0",
                    right: "0",
                    bottom: "0",
                    zIndex: "999",
                  }}></div>

                <div class="dropdown" style={{ zIndex: "9999" }}>
                  <ul className="dropdownul">
                    {props.role !== "protrustee" && (
                      <li
                        className="liHover"
                        onClick={() => {
                          deleteSelectedRow(record.id);
                          setDropdown(false);
                        }}>
                        Delete
                      </li>
                    )}
                    {props.role !== "protrustee" && (
                      <li
                        className="liHover"
                        onClick={() => {
                          setShowUpdateModal(true);
                          setDropdown(false);
                        }}>
                        Update
                      </li>
                    )}
                    <li
                      className="liHover"
                      onClick={() => {
                        setShowViewModal(true);
                        setDropdown(false);
                      }}>
                      View
                    </li>
                  </ul>
                </div>
              </>
            )}{" "}
          </div>
        );
      },
    },
  ];
  return (
    <div>
      {showModal && (
        <AddModal
          show={showModal}
          close={handelCloseModal}
          fields={fields}
          modalTitle="Add New Personal Instruction"
          handlechange={handlechange}
          submitData={submitData}
          handleDocumentChange={handleDocumentChange}
          handleDatePickerChange={handleDatePickerChange}
          handleRadioChange={handleRadioChange}
        />
      )}
      {showUpdateModal && (
        <UpdateModal
          show={showUpdateModal}
          close={handelCloseUpdateModal}
          fields={update_fields}
          modalTitle="Update Personal Instructions"
          handlechange={handleUpdatechange}
          submitData={SubmitUpdate}
          handleDocumentChange={handleUpdateDocumentChange}
          handleDatePickerChange={handleUpdateDatePickerChange}
          handleRadioChange={handleUpdateRadioChange}
          obj={updateObject}
        />
      )}
      {showViewModal && (
        <ViewModal
          show={showViewModal}
          close={handelCloseViewModal}
          fields={update_fields}
          modalTitle="View Personal Instructions"
          obj={updateObject}
        />
      )}
      <Modal
        centered
        visible={tooltipModal}
        footer={null}
        onCancel={handleTooltipCancel}>
        <Style.ModalTitle> Personal Instructions</Style.ModalTitle>
        <div style={{}}>
          <div className="">
            <Style.ModalDetails>
              The designers of this software solution have decades of experience
              in financial wealth management and helping people, and they
              believe it was critical for a Plan Creator to create, and possibly
              amend, personal notes. These notes are the types of items that
              might not be in a Will or Trust and can highly personal,
              secretive, or simple instructions. That favorite collectible item
              you didn’t mention in a Will or Trust but feel the need to use a
              Personal Note for added clarity, this small note might help reduce
              bickering amongst those in conflict over such items. Personal
              notes might range from added care of a pet, or something salacious
              such as having a secret family. Personal Instructions is another
              tool to help Plan Creators communicate their wishes and their
              intent to those they leave behind when they die.
            </Style.ModalDetails>
          </div>
        </div>
      </Modal>

      <Style.MainHeading>
        {/* <Style.HeaderImg src={Safe} alt="Safe"></Style.HeaderImg> */}
        Personal Instructions{" "}
        <Style.HelpIcon
          src={helpIcon}
          alt="helpicon"
          onClick={() => {
            showTooltipModal();
          }}></Style.HelpIcon>
      </Style.MainHeading>

      <Style.HealthCard>
        <Style.HealthCardHeader>
          <Style.Title style={{}}>Personal Instructions</Style.Title>
          {props.role !== "protrustee" && (
            <div>
              <Style.Button
                onClick={() => {
                  setShowModal(true);
                  console.log("modaldata", addData);
                }}>
                +
              </Style.Button>
            </div>
          )}
        </Style.HealthCardHeader>
        <List cols={cols} rows={personalInstruction}></List>
      </Style.HealthCard>
      <Loader isLoading={loading} />
    </div>
  );
};
